import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const CampaignNewRequestsCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `حملتك الترويجية استقبلت عروض جديدة`
          : 'Your campaign has recieved new offers'
      }
    />
  )
}

export default CampaignNewRequestsCover
